export default {
  data: () => ({
    apoIds: [],
  }),
  methods: {
    updateRegop(list) {
      this.apoIds = []
      list.forEach((item) => {
        if (item.checked) {
          this.apoIds.push(item.id)
        } else {
          const index = this.apoIds.findIndex((item) => item === item.id)
          if (index !== -1) {
            this.apoIds.splice(index, 1)
          }
        }
      })
      this.geoObjectsById({ apoIds: this.apoIds.join(',') })
    },
  },
}
